import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSendBatchPayment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 186,
	height: 186,
	viewBox: "0 0 186 186",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_2_72)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 93,
				cy: 88,
				r: 63,
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2_72)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M109.166 70.4095H77.7367C76.4261 70.4095 75.1691 70.934 74.2424 71.8676C73.3156 72.8012 72.795 74.0675 72.795 75.3878V107.025C72.795 108.345 73.3156 109.611 74.2424 110.545C75.1691 111.479 76.4261 112.003 77.7367 112.003H109.166C110.476 112.003 111.733 111.479 112.66 110.545C113.587 109.611 114.108 108.345 114.108 107.025V75.3753C114.104 74.0572 113.582 72.7941 112.656 71.8632C111.729 70.9323 110.474 70.4095 109.166 70.4095ZM93.5501 106.403C93.0509 106.424 92.5562 106.301 92.124 106.048C91.6918 105.796 91.3401 105.424 91.1101 104.978H95.7677C95.5532 105.389 95.2357 105.737 94.8468 105.987C94.4578 106.237 94.0109 106.38 93.5501 106.403ZM97.3552 102.706C97.3552 102.952 97.2582 103.188 97.0856 103.362C96.913 103.536 96.6789 103.633 96.4348 103.633H90.443C90.1989 103.633 89.9648 103.536 89.7922 103.362C89.6196 103.188 89.5226 102.952 89.5226 102.706V102.414C89.5242 102.169 89.6219 101.935 89.7944 101.762C89.9668 101.59 90.2 101.493 90.443 101.493H96.4348C96.6778 101.493 96.911 101.59 97.0834 101.762C97.2559 101.935 97.3536 102.169 97.3552 102.414V102.706ZM97.3552 99.2214C97.3593 99.3458 97.3386 99.4697 97.2942 99.5858C97.2498 99.7019 97.1827 99.8078 97.0968 99.8972C97.0109 99.9867 96.908 100.058 96.7943 100.106C96.6806 100.155 96.5583 100.18 96.4348 100.18H90.443C90.1989 100.18 89.9648 100.082 89.7922 99.9081C89.6196 99.7343 89.5226 99.4984 89.5226 99.2525V98.9351C89.5242 98.6903 89.6219 98.4561 89.7944 98.2835C89.9668 98.111 90.2 98.0142 90.443 98.0142H96.4348C96.6778 98.0142 96.911 98.111 97.0834 98.2835C97.2559 98.4561 97.3536 98.6903 97.3552 98.9351V99.2214ZM98.5041 92.9985C98.1497 93.2426 97.8613 93.5719 97.665 93.9565C97.4687 94.3411 97.3707 94.769 97.3799 95.2014C97.3799 95.5927 97.2269 95.9681 96.9541 96.2465C96.6812 96.5249 96.3104 96.6838 95.9221 96.6887H91.0792C90.6664 96.6887 90.2705 96.5235 89.9785 96.2294C89.6866 95.9353 89.5226 95.5364 89.5226 95.1205C89.5256 94.7091 89.4273 94.3033 89.2365 93.9395C89.0457 93.5757 88.7683 93.2652 88.4293 93.0359C87.1133 92.1768 86.0375 90.9927 85.3044 89.5962C84.5713 88.1997 84.2052 86.6375 84.2412 85.0581C84.3228 82.6355 85.3416 80.341 87.0801 78.6651C88.8186 76.9891 91.1387 76.0645 93.5448 76.0889C95.9509 76.1133 98.2522 77.0847 99.9568 78.7955C101.661 80.5064 102.634 82.821 102.668 85.2448C102.67 86.7871 102.291 88.3056 101.564 89.6629C100.837 91.0201 99.7854 92.1731 98.5041 93.0172V92.9985Z",
					fill: "#FFCE32"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.4492,
					y: 70.0185,
					width: 42.0508,
					height: 41.9841,
					rx: 6.05635,
					fill: "#FFCE32"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.4492,
					y: 70.0186,
					width: 42.0508,
					height: 41.9841,
					rx: 6.05635,
					fill: "#FFCE32"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.4492,
					y: 70.0186,
					width: 42.0508,
					height: 41.9841,
					rx: 6,
					fill: "url(#paint0_linear_2_72)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M76.9121 68.8721C76.9121 67.7675 77.8075 66.8721 78.9121 66.8721H108.037C109.142 66.8721 110.037 67.7675 110.037 68.8721V68.8721H76.9121V68.8721Z",
					fill: "#F09337"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80.9746 65.7256C80.9746 64.621 81.87 63.7256 82.9746 63.7256H103.975C105.079 63.7256 105.975 64.621 105.975 65.7256V65.7256H80.9746V65.7256Z",
					fill: "#F09337"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.269 99.3682C93.1341 99.3682 93.0299 99.3253 92.9564 99.2395C92.8828 99.166 92.8461 99.0679 92.8461 98.9453V97.6582C91.9512 97.5847 91.1973 97.3824 90.5844 97.0514C89.9715 96.7082 89.5056 96.2975 89.1869 95.8194C88.8682 95.3414 88.6966 94.8326 88.6721 94.2933C88.6721 94.1952 88.7088 94.1094 88.7824 94.0358C88.8682 93.95 88.9663 93.9071 89.0766 93.9071H90.0144C90.1615 93.9071 90.2718 93.9439 90.3453 94.0175C90.4189 94.091 90.4679 94.1768 90.4924 94.2749C90.566 94.5691 90.7192 94.8633 90.9521 95.1575C91.185 95.4394 91.516 95.6785 91.9451 95.8746C92.3864 96.0585 92.9503 96.1504 93.6367 96.1504C94.691 96.1504 95.4632 95.9665 95.9536 95.5988C96.4562 95.2188 96.7075 94.7162 96.7075 94.091C96.7075 93.662 96.5726 93.3187 96.3029 93.0613C96.0455 92.7916 95.6471 92.5526 95.1077 92.3442C94.5684 92.1358 93.8696 91.909 93.0115 91.6638C92.1167 91.4064 91.3751 91.1245 90.7866 90.818C90.1982 90.5115 89.7569 90.1315 89.4627 89.678C89.1808 89.2244 89.0398 88.6483 89.0398 87.9495C89.0398 87.0547 89.3708 86.2885 90.0328 85.6511C90.6947 85.0014 91.6325 84.6214 92.8461 84.5111V83.2423C92.8461 83.1197 92.8828 83.0217 92.9564 82.9481C93.0299 82.8623 93.1341 82.8194 93.269 82.8194H93.9677C94.0903 82.8194 94.1884 82.8623 94.2619 82.9481C94.3477 83.0217 94.3906 83.1197 94.3906 83.2423V84.5294C95.2119 84.6275 95.8984 84.8543 96.45 85.2098C97.0017 85.5653 97.4184 85.9759 97.7004 86.4418C97.9823 86.9076 98.1294 87.3611 98.1417 87.8024C98.1417 87.8883 98.111 87.9741 98.0498 88.0599C97.9885 88.1334 97.8904 88.1702 97.7556 88.1702H96.781C96.6952 88.1702 96.6033 88.1457 96.5052 88.0966C96.4194 88.0476 96.352 87.9557 96.3029 87.8208C96.2294 87.3182 95.9474 86.8953 95.4571 86.5521C94.9668 86.2088 94.3293 86.0372 93.5448 86.0372C92.748 86.0372 92.0983 86.1905 91.5957 86.4969C91.1054 86.8034 90.8602 87.2815 90.8602 87.9312C90.8602 88.3479 90.9767 88.6973 91.2096 88.9792C91.4425 89.2489 91.8102 89.488 92.3128 89.6964C92.8154 89.9048 93.4712 90.1254 94.2803 90.3583C95.261 90.628 96.0639 90.9161 96.6891 91.2225C97.3143 91.5167 97.7739 91.8906 98.0681 92.3442C98.3746 92.7855 98.5278 93.3555 98.5278 94.0542C98.5278 94.753 98.3562 95.3597 98.013 95.8746C97.682 96.3895 97.2039 96.8001 96.5787 97.1066C95.9658 97.413 95.2365 97.603 94.3906 97.6766V98.9453C94.3906 99.0679 94.3477 99.166 94.2619 99.2395C94.1884 99.3253 94.0903 99.3682 93.9677 99.3682H93.269Z",
					fill: "#1E63FF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 106.113,
			y: 103.717,
			width: 17.773,
			height: 14.4406,
			fill: "white",
			stroke: "white",
			strokeWidth: 3.33244
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115 98.1629C108.252 98.1629 102.781 103.634 102.781 110.382C102.781 117.13 108.252 122.601 115 122.601C121.748 122.601 127.219 117.13 127.219 110.382C127.219 103.634 121.748 98.1629 115 98.1629Z",
			fill: "#FFCE32",
			stroke: "white",
			strokeWidth: 3.33244
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.89 108.438L115 105.384L121.109 108.438L115 111.493L108.89 108.438Z",
			fill: "white",
			stroke: "white",
			strokeWidth: 1.55514,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M108.89 112.604L115 115.659L121.109 112.604",
			stroke: "white",
			strokeWidth: 1.55514,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_2_72",
				x: 0,
				y: 0,
				width: 186,
				height: 186,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 5 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 15 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.675 0 0 0 0 0.7125 0 0 0 0 0.75 0 0 0 0.25 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_2_72"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_2_72",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2_72",
				x1: 82.2932,
				y1: 128.368,
				x2: 93.4397,
				y2: 91.0002,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .0820223,
						stopColor: "#F09337"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .506944,
						stopColor: "#F09337",
						stopOpacity: .537111
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#F09337",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_2_72",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 43,
					height: 50,
					fill: "white",
					transform: "translate(72 63)"
				})
			})
		] })
	]
});
export default SvgSendBatchPayment;
